/**
 * Halftone Overlay V2 - Split Layout
 * Manages the overlay modal open/close functionality
 *
 * @version 2.1.0
 */

(function () {
  'use strict';

  // ============================================================================
  // STATE
  // ============================================================================

  let overlay = null;
  let backdrop = null;
  let closeBtn = null;
  let isOpen = false;
  let previousFocus = null;

  // ============================================================================
  // INITIALIZATION
  // ============================================================================

  function init() {
    overlay = document.querySelector('.halftone-overlay-container');

    if (!overlay) {
      console.warn('HalftoneOverlay V2: No overlay container found');
      return;
    }

    backdrop = overlay;
    closeBtn = overlay.querySelector('.halftone-close-overlay');

    if (overlay.parentElement && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeOverlay);
    }

    if (backdrop) {
      backdrop.addEventListener('click', function (e) {
        if (e.target === backdrop) {
          closeOverlay();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) {
        closeOverlay();
      }
    });

    console.log('HalftoneOverlay V2: Initialized');
  }

  // ============================================================================
  // PUBLIC API
  // ============================================================================

  function openOverlay() {
    if (!overlay || isOpen) return;

    previousFocus = document.activeElement;

    // Scrollbar width compensation to prevent layout shift
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = scrollBarWidth + 'px';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('halftone-modal-open');

    overlay.classList.add('visible');
    overlay.style.display = 'flex';

    setTimeout(() => {
      const firstInput = overlay.querySelector('input, button:not(.halftone-close-overlay)');
      if (firstInput) firstInput.focus();
    }, 100);

    isOpen = true;
    document.dispatchEvent(new CustomEvent('halftone-overlay-open', { detail: { overlay } }));
  }

  function closeOverlay() {
    if (!overlay || !isOpen) return;

    overlay.classList.remove('visible');

    setTimeout(() => {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.body.classList.remove('halftone-modal-open');

      if (previousFocus) previousFocus.focus();
      isOpen = false;
      document.dispatchEvent(new CustomEvent('halftone-overlay-close', { detail: { overlay } }));
    }, 300);
  }

  window.HalftoneOverlayV2 = {
    open: openOverlay,
    close: closeOverlay,
    isOpen: () => isOpen,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
